import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { generatePath, useNavigate } from 'react-router';

import { Dialog } from '@sorare/core/src/components/dialog';
import { NBA_PLAY_CHASE_USERGROUP } from '@sorare/core/src/constants/__generated__/routes';
import { getSafePreviousLocation } from '@sorare/core/src/lib/navigation/getSafePreviousLocation';

import { CumulativePaginatedRankings } from '#src/components/leaderboard/CumulativePaginatedRankings/index.tsx';
import { WithChaseHeaderLayout } from '#src/layouts/WithChaseHeaderLayout/index.tsx';

import type { ChampionshipLeaderboard_so5UserGroup } from './__generated__/index.graphql.ts';

type Props = {
  so5UserGroup: ChampionshipLeaderboard_so5UserGroup;
};
export const ChampionshipLeaderboard = ({ so5UserGroup }: Props) => {
  const navigate = useNavigate();
  const safePreviousLocation = getSafePreviousLocation(
    generatePath(NBA_PLAY_CHASE_USERGROUP, {
      userGroup: so5UserGroup.slug,
    })
  );

  return (
    <Dialog
      hideHeader
      open
      onClose={() => navigate(safePreviousLocation)}
      fullScreen
    >
      <WithChaseHeaderLayout
        so5UserGroup={so5UserGroup}
        backTo={safePreviousLocation}
      >
        <CumulativePaginatedRankings
          userGroupSlug={so5UserGroup.slug}
          withCollapsibleRanking
        />
      </WithChaseHeaderLayout>
    </Dialog>
  );
};

ChampionshipLeaderboard.fragments = {
  so5UserGroup: gql`
    fragment ChampionshipLeaderboard_so5UserGroup on So5UserGroup {
      slug
      ...WithChaseHeaderLayout_so5UserGroup
    }
    ${WithChaseHeaderLayout.fragments.so5UserGroup}
  ` as TypedDocumentNode<ChampionshipLeaderboard_so5UserGroup>,
};
